import {Component, Injector} from '@angular/core';
import {Store as StoreStore, StoreState} from './state/store';
import {Store} from './state/model';
import {StoreService as StoreService} from './state/service';
import {EntityDetailComponent} from '../../components/entity-detail/component';
import {FormBuilder} from '@angular/forms';
import {StoreQuery} from './state/query';

@Component({
  templateUrl: '../../components/entity-detail/component.html',
  styleUrls: ['../../components/entity-detail/component.scss']
})
export class StoreDetailComponent extends EntityDetailComponent<Store, StoreState, StoreStore> {

  constructor(
    public injector: Injector,
    service: StoreService,
    protected query: StoreQuery,
    protected formBuilder: FormBuilder) {
    super(injector, service, query);
  }
}
